import { useEffect, useState } from "react";
import Alert from "../../components/alert";
import Badge from "../../components/badge";
import Card from "../../components/card";
import { useLayoutContext } from "../../context/game"
import { useLightboxContext } from "../../context/lightbox";
import { useClockContext } from "../../context/clock";
import './question.scss';
export default function Question({setRoute,count}){
	const questions = window['game_data']['questions'] || {};
	const optionsList = window['game_data']['options'] || {};
	const answers = window['game_data']['answers'] || {};
	const params = new URLSearchParams(window.location.search);
	const current = window.current || params.get('current') || null;
	const fromBuilder = {
		qId:Object.keys(questions)[+current - 1],
		options: optionsList[Object.keys(questions)[+current - 1]],
	}
	const [context,setContext] = useLayoutContext();
	const [question,setQuestion] = useState(current !== null ? questions[fromBuilder.qId] : null);
	const [options,setOptions] = useState(current !== null ? fromBuilder.options :{});
	const [_,setLightbox] = useLightboxContext();
	const [correct,setCorrect] = useState(null)
	const [a,b,start,stop] = useClockContext();
	useEffect(()=>{
		if(!context?.current) return;
		if(context?.penalty !== true) stop(true);
		setQuestion(questions[context.current])

		const questionAnswer = optionsList[context.current];
		setOptions(questionAnswer);
	},[context?.current])

	const onClickOpt = (oId) =>{
		const qAnswer = answers[current !== null ? fromBuilder.qId : context?.current]
		const isCorrect = qAnswer === oId;
		setCorrect(isCorrect);
		isCorrect && stop();
		setTimeout(()=>{
			setCorrect(null)
			if(window.builder === true || current !== null) return;
			if(isCorrect){
				const answered = {...context?.answered,[context.current]:oId};
				setContext({hasStarted:false,penalty:false,current:null,answered});
				stop(true,true)
				if(Object.keys(answered).length === count){
					setRoute('title');
					return;
				}
				setRoute('questions');
			} else {
				const qId = context.current;
				const wrong = context.wrong || [];
				if(!wrong.includes(qId)){
					wrong.push(qId)
				}
				setContext({...context,wrong})
			}
		},1500)
	}
	if (Object.keys(questions).length === 0) {
		return (
			<div className="row g-0 px-3">
				<div className="col-xl-6 col-lg-8 mx-auto py-5">
					<Card className="align-items-center">
						<svg className='mb-4' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="72" height="72"><path fill="none" d="M0 0h24v24H0z" /><path fill='#F5B736' d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm-1-5h2v2h-2v-2zm0-8h2v6h-2V7z" /></svg>
						<h2>Žaidimo peržiūra bus sugeneruota kai užpildysite bent vieną įrašą.</h2>
					</Card>
				</div>
			</div>
		)
	}
	return(<>
		<div className="position-relative py-5 flex-grow-1">
			<div className='game-bg'></div>
			<div className="container">
				<div className="vpe-card justify-content-start">
					<div style={{textAlign:'left'}}>
						<Back setRoute={setRoute}/>
					</div>
					<div className="row">
						<div className="col-lg-5">
							<div className="text-center pt-3 mb-n2">
								<Badge className="heads mb-n3 fw-600">
									{question?.title}
								</Badge>
							</div>
						</div>
					</div>
					<div className="row">
						<div className="col-lg-5">
							<div className="question-card-text bg-white pt-5 rounded">
								<div className="pb-2">{question?.text}</div>
							</div>
						</div>
						<div className="col-lg-7 pt-5 pt-lg-0">
							<div className="option-wrap row g-3">
								{options && Object.keys(options).map((oId)=>{
									const {text,img} = options[oId];
									return(
										<div className="col-lg-6 option-col" key={oId}>
											<div className="option" onClick={({target})=>{
												if(target.closest('.option-img-zoom')) return;
												onClickOpt(oId)
											}}>
												{img ? (
													<div className="option-img-wrap">
														<div className="option-img-zoom" onClick={(ev)=>{
															ev.preventDefault();
															ev.stopPropagation();
															setLightbox(img);

														}}>
															<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path fill="currentColor" d="M18.031 16.617l4.283 4.282-1.415 1.415-4.282-4.283A8.96 8.96 0 0 1 11 20c-4.968 0-9-4.032-9-9s4.032-9 9-9 9 4.032 9 9a8.96 8.96 0 0 1-1.969 5.617zm-2.006-.742A6.977 6.977 0 0 0 18 11c0-3.868-3.133-7-7-7-3.868 0-7 3.132-7 7 0 3.867 3.132 7 7 7a6.977 6.977 0 0 0 4.875-1.975l.15-.15zM10 10V7h2v3h3v2h-3v3h-2v-3H7v-2h3z"/></svg>
														</div>
														<img src={img} alt={text} className="option-img mw-100" />
													</div>
													) : (
													<div className="option-img-wrap empty">
														<span></span>
													</div>
												)}
												{text && (
													<div className="option-text">{text}</div>
												)}
											</div>
										</div>
									)
								})}
							</div>
						</div>
					</div>
				</div>
				{correct !== null && (
					<div className="alert-wrap">
						<Alert
							isCorrect={correct}
						/>
					</div>
				)}
			</div>
		</div>
	</>)
	function Back() {
		const btn = {
			color: '#163C60',
			fontWeight: '600',
			display: 'inline-flex',
			alignItems: 'center',
			padding: '.5rem',
			border: 'none',
			background: 'transparent',
		}
		return (
			<button onClick={() => { setRoute('questions'); setContext({...context,penalty:true}) }} style={btn}>
				<svg className="me-3" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M3.828 7.00066H16V9.00066H3.828L9.192 14.3647L7.778 15.7787L0 8.00066L7.778 0.222656L9.192 1.63666L3.828 7.00066Z" fill="currentColor" />
				</svg>
				Grįžti į kortelių pasirinkimą
			</button>
		)
	}
}
